import React, { FC } from 'react';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import { secondsToHMS } from '@utils/time.utils';
import {
    Capitol,
    CapitolIcon,
    CapitolTime,
    CapitolTitle,
    Capitols,
    Title,
    Wrapper,
} from './TrainingChapters.elements';

export interface TrainingChaptersProps {
    chapters: {
        time: number;
        title: string;
    }[];
    videoKey: string;
}

const TrainingChaptersTemplate: FC<TrainingChaptersProps> = ({ chapters, videoKey }) => {
    const { t } = useTranslations();

    const movePlayTimeToSelectedPosition = (time: number) => {
        const element = document.getElementById(`video-${videoKey}`);

        if (element) {
            (element as HTMLVideoElement).currentTime = time;
        }
    };

    return (
        <Wrapper>
            {chapters?.length > 0 && (
                <>
                    <Title>Kapitoly:</Title>
                    <Capitols>
                        {chapters?.map((chapter, key) => (
                            <Capitol onClick={() => movePlayTimeToSelectedPosition(chapter.time)} key={key}>
                                <CapitolTime>{secondsToHMS(chapter.time)}</CapitolTime>
                                <CapitolIcon name={Icons.Play} />
                                <CapitolTitle>
                                    {key + 1} {chapter.title}
                                </CapitolTitle>
                            </Capitol>
                        ))}
                    </Capitols>
                </>
            )}
        </Wrapper>
    );
};

export default TrainingChaptersTemplate;
